import { Controller } from "@hotwired/stimulus"

/**
 * Copy Prompt Controller
 * 
 * Copies a pre-generated AI translation prompt to the clipboard.
 * Shows feedback when copy is successful.
 * 
 * Usage:
 *   <div data-controller="copy-prompt"
 *        data-copy-prompt-text-value="prompt text here">
 *     <button data-action="click->copy-prompt#copy" 
 *             data-copy-prompt-target="button">
 *       Copy Prompt
 *     </button>
 *   </div>
 */
export default class extends Controller {
  static values = { text: String }
  static targets = ["button"]

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.showSuccess()
    } catch (err) {
      this.showError()
    }
  }

  showSuccess() {
    const originalText = this.buttonTarget.innerHTML
    const originalClass = this.buttonTarget.className
    
    this.buttonTarget.innerHTML = '<i class="fa-solid fa-check me-1" aria-hidden="true"></i> Copied!'
    this.buttonTarget.classList.remove('btn-outline-primary')
    this.buttonTarget.classList.add('btn-success')
    
    setTimeout(() => {
      this.buttonTarget.innerHTML = originalText
      this.buttonTarget.className = originalClass
    }, 2000)
  }

  showError() {
    const originalText = this.buttonTarget.innerHTML
    const originalClass = this.buttonTarget.className
    
    this.buttonTarget.innerHTML = '<i class="fa-solid fa-times me-1" aria-hidden="true"></i> Failed'
    this.buttonTarget.classList.remove('btn-outline-primary')
    this.buttonTarget.classList.add('btn-danger')
    
    setTimeout(() => {
      this.buttonTarget.innerHTML = originalText
      this.buttonTarget.className = originalClass
    }, 2000)
  }
}
